import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "my-5 align-center" }
const _hoisted_2 = { class: "mb-0" }
const _hoisted_3 = { class: "mb-0" }

import i18n from '@/lang/i18n';
import RegisterModal from "@/components/Common/RegisterModal.vue";
import { computed } from "vue";
import { UNEXPECTED_EVENT_KEY, SPECIAL_EXTENSION_KEY } from "@/services/consts";


export default /*@__PURE__*/_defineComponent({
  __name: 'SpecialCaseSelectModal',
  props: {
    modelValue: { type: Boolean }
  },
  emits: ['update:modelValue', 'cancel', 'openModal'],
  setup(__props: any, { emit: __emit }) {

const emits = __emit

const props = __props

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emits('update:modelValue', value);
  },
})

function openModal(key: string) {
  emits('openModal', key)
}

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createBlock(RegisterModal, {
    modelValue: modelValue.value,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((modelValue).value = $event)),
    modalMaxWidth: "30%"
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", null, [
          _createVNode(_component_v_btn, {
            variant: "text",
            class: "w-100 d-flex justify-content-start px-2",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (openModal(_unref(UNEXPECTED_EVENT_KEY))))
          }, {
            default: _withCtx(() => [
              _createElementVNode("p", _hoisted_2, _toDisplayString(_unref(i18n).global.t('pages.dailyReports.updateModal.registerUnexpectedEvents')), 1)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_v_btn, {
            variant: "text",
            class: "w-100 d-flex justify-content-start px-2 mt-3",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (openModal(_unref(SPECIAL_EXTENSION_KEY))))
          }, {
            default: _withCtx(() => [
              _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(i18n).global.t('pages.dailyReports.updateModal.registerSpecialExtensionContinuousOperation')), 1)
            ]),
            _: 1
          })
        ])
      ])
    ]),
    buttons: _withCtx(() => [
      _createVNode(_component_v_btn, {
        class: "ma-2 reset-btn",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (modelValue.value = false))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(i18n).global.t('common.cancelBtn')), 1)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})